var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":"confirmar","rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return _c('el-form-item',{attrs:{"error":errors[0],"label":_vm.$attrs.label}},[_c('el-checkbox-group',{model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},[_vm._t("default")],2)],1)}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }